import { graphql, useStaticQuery } from "gatsby";
import Image from "../Image";

const Trust = ({ alt = 'trust', ...props}) => {
  const { trust } = useStaticQuery(graphql`
    query {
      trust: file(base: { eq: "trust.svg" }) {
        publicURL
      }
    }
  `);

  return (
    <Image className="w-18 mr-8" src={trust && trust.publicURL} alt={alt} {...props} />
  )
}

export default Trust;
